module.exports = __webpack_public_path__ + "img/Referral-Antennas.64306895.png";